export enum DataSourceDataType {
  BOOLEAN = 'BOOLEAN',
  INTEGER = 'INTEGER',
  SMALLINT = 'SMALLINT',
  BIGINT = 'BIGINT',
  DECIMAL = 'DECIMAL',
  VARCHAR = 'VARCHAR',
  TEXT = 'TEXT',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  JSON = 'JSON',
}

export const DataSourceDataTypes = [
  DataSourceDataType.BOOLEAN,
  DataSourceDataType.INTEGER,
  DataSourceDataType.SMALLINT,
  DataSourceDataType.BIGINT,
  DataSourceDataType.DECIMAL,
  DataSourceDataType.VARCHAR,
  DataSourceDataType.TEXT,
  DataSourceDataType.DATE,
  DataSourceDataType.DATETIME,
  DataSourceDataType.JSON,
];

export const DataSourceDataTypeMap = new Map<string, DataSourceDataType>([
  ['boolean', DataSourceDataType.BOOLEAN],
  ['integer', DataSourceDataType.INTEGER],
  ['smallint', DataSourceDataType.SMALLINT],
  ['bigint', DataSourceDataType.BIGINT],
  ['decimal', DataSourceDataType.DECIMAL],
  ['varchar', DataSourceDataType.VARCHAR],
  ['text', DataSourceDataType.TEXT],
  ['date', DataSourceDataType.DATE],
  ['datetime', DataSourceDataType.DATETIME],
  ['json', DataSourceDataType.JSON],
]);

export const validDataTypes = [
  DataSourceDataType.INTEGER,
  DataSourceDataType.SMALLINT,
  DataSourceDataType.BIGINT,
  DataSourceDataType.DATE,
  DataSourceDataType.DATETIME,
];
